import { render } from "./GlobalProgress.vue?vue&type=template&id=72023803"
import script from "./GlobalProgress.vue?vue&type=script&lang=js"
export * from "./GlobalProgress.vue?vue&type=script&lang=js"

import "./GlobalProgress.vue?vue&type=style&index=0&id=72023803&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__